import React from "react";
import Label from "components/general/Label"
import Card from 'react-bootstrap/Card';
import DateTime from "components/presentation/DateTime"
import Status from "components/presentation/Status";
import { isLiveStatus, isLessLiveStatus } from "helpers/status";
import Noc from "components/presentation/Noc";
import Competitor from "components/presentation/Competitor";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import { getDateTimeFormat } from "helpers/utils";



export function Footer({ data }) {
    const formatDate = getDateTimeFormat('DayMonthShort')
    const formatDateTime = getDateTimeFormat('DayMonthShortHourMinute');
    const dateTime = data?.bi_date + ' ' + data?.bi_time
    const dateTimeFormated = data?.bi_date && <DateTime datetime={dateTime} format={formatDateTime} />
    const date = data?.bi_date && <><DateTime datetime={data?.bi_date} format={formatDate} />, <SportCode entity='@CompetitorPlace' code="TBD" abbr={true} /></>
    const dateComponent = data?.bi_time ? dateTimeFormated : date
    const numberGame = data?.bracketItemCode

    return (
        <>
            {isLiveStatus(data?.result?.status?.code) && <div className='score-status justify-content-end'>
                <Status typeToPrint={'result'} scheduleStatus={data?.schedule?.status?.code} resultStatus={data?.result?.status?.code} />
            </div>}
            <div className="d-flex">
                {isLessLiveStatus(data?.result?.status?.code) && <div className='text-start w-50'>{dateComponent}</div>}
                {isLessLiveStatus(data?.result?.status?.code) && <div className='text-end w-50'><Label data='HeaderGame' /> {numberGame}</div>}
            </div>
        </>
    )
}

export function CompetitorBlockNoData(competitor) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let competitorPlace = competitor?.cp_code ? <SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={competitor?.cp_code} notFound={<>&nbsp;</>} /> : ''
    let code = competitor?.cp_prev_unit?.code;
    let label = <Label data={competitor?.cp_prev_pos?.includes('QFNL') ? 'LabelQuarterfinal' : 'HeaderSFL'} />
    let unit = code && code?.length > 33 ? code.slice(29, 30) : ''
    return (
        <div className=' d-flex flex-row justify-content-start'>
            <div className=''>
                {competitorPlace
                    ? competitorPlace
                    : !competitor.cp_prev_wlt
                        ? competitor?.cp_prev_pos
                        : competitor?.cp_prev_wlt === 'W'
                            ? <><Label data='HeaderWinner' /> {label} {unit}</>
                            : <><Label data='LabelLooserDesc' /> {label} {unit}</>
                }
            </div>
        </div>
    )
}

export function Header({ data, bracket, phase }) {
    return (
        <Card.Header className={data?.code !== 'CLEAN' ? 'visible' : 'invisible'}>
            <div className='score-header'>
                <b><span>{data?.eventUnit?.shortDescription}</span></b>
            </div>
        </Card.Header>
    )
}

export function CompetitorBlock(competitor) {
    const bolding = competitor?.cp_wlt === 'W' ? 'fw-bold' : '';
    return (
        <>
            {competitor?.cp_pos === '1' &&
                <div className="score-competitor-container d-flex justify-content-start text-truncate">
                    <div className="fw-bold w-20"><Label data='HeaderBib' /></div>
                    <div className={"fw-bold"}><Label data='HeaderName' /></div>
                </div>
            }
            <div className="score-competitor-container d-flex justify-content-start text-truncate">
                <div className={'text-center w-30'}>
                    {competitor?.resultItem?.bib}
                </div>
                <div className={`score-noc ${bolding}`}>
                    <Noc className='me-1' {...competitor?.participant?.organisation} />
                </div>
                <div className={`score-name align-items-center ${bolding}`}>
                    <Competitor  {...competitor?.participant} hideNoc={true} hidePicture={true} noLink={true} onlyShortName={true} screen={competitor.screen} />
                </div>
            </div>
        </>
    )
}


